<div class="maindiv">
    <simple-datagrid [entityName]="entityName" [parentRow]="parentRow" [condition]="condition" [componentedit]="comp" [templateIdForAdd]="templateIdForAdd"></simple-datagrid>
</div>
